/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNotification = createReactComponent("notification", "IconNotification", [
  [
    "path",
    {
      d: "M10 6h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3",
      key: "svg-0"
    }
  ],
  ["path", { d: "M17 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-1" }]
]);

export { IconNotification as default };
//# sourceMappingURL=IconNotification.js.map
